import { useState } from 'react'
import { useSelector } from 'react-redux'
import ShowHideGroup from '../../../assests/imgs/icons/showHIdeGroup.png'
import { calculateMobileElementsPerRow, getDepartmentIcon, getSubdivisionIcon } from '../../../global/utils/iconsUtils'
import CancledCol from './columns/CancledCol'
import FinishedCol from './columns/FinishedCol'
import NameCol from './columns/NameCol'
import PausedCol from './columns/PausedCol'
import PlanedCol from './columns/PlanedCol'
import QueueCol from './columns/Queue'
import WorkingCol from './columns/WorkingCol'

const GroupRowMobile = ({ group }) => {

    const [show, setShow] = useState(true)

    const { allSubdivisionsList, icons } = useSelector(state => state.implementers)

    // Динамически рассчитываем количество элементов на строку
    const elementsPerRow = calculateMobileElementsPerRow(group.list.length);

    const answer = allSubdivisionsList.find((department) => {
        return department.list.find(sub => sub.subdivision_uuid === group.subdivision.uuid)
    })

    const getDepartmentData = () => {
        const uuid = answer?.group_uuid || group.subdivision.uuid
        // Получаем иконку с приоритетом: custom subdivision -> department
        const icon = getSubdivisionIcon(group.subdivision.uuid, uuid, icons) ||
            getDepartmentIcon(uuid, icons);
        return {
            icon: icon,
        }
    }

    const deptData = getDepartmentData()
    const groupImg = deptData?.icon

    const showOrHide = () => setShow(!show)

    return (
        <>
            <div key={group.subdivision.uuid} >
                <div className='main_mobile_footer' onClick={showOrHide}>
                    <div>
                        <img className={show ? '' : 'rotate180'} src={ShowHideGroup} />
                    </div>

                    {groupImg && <img src={groupImg} style={{ maxHeight: 30, maxWidth: 90 }} />}
                    <p>{group.subdivision.name}</p>
                </div>
                <div style={{ display: 'flex' }}>
                    {
                        show ? <>
                            <div className='main_mobile_header_table_row_name minWidth290'>
                                {group.list.map(((implementer, i) => <NameCol key={i} name={implementer.name_rus} />))}
                            </div>
                            <div className='main_mobile_header_table_row'>
                                {group.list.map(((implementer, i) => <QueueCol key={i} counts={implementer.counts} />))}
                            </div>
                            <div className='main_mobile_header_table_row_planned '>
                                {group.list.map(((implementer, i) => <PlanedCol key={i} planned={implementer.counts.planned} />))}
                            </div>
                            <div className='main_mobile_header_table_row '>
                                {group.list.map(((implementer, i) => <WorkingCol key={i} working={implementer.counts.working} />))}
                            </div>
                            <div className='main_mobile_header_table_row'>
                                {group.list.map(((implementer, i) => <PausedCol key={i} paused={implementer.counts.paused} />))}
                            </div>
                            <div className='main_mobile_header_table_row '>
                                {group.list.map(((implementer, i) => <FinishedCol key={i} finished={implementer.counts.finished} />))}
                            </div>
                            <div className='main_mobile_header_table_row '>
                                {group.list.map(((implementer, i) => <CancledCol key={i} cancled={implementer.counts.cancled} />))}
                            </div>
                        </>
                            : null
                    }
                </div>


            </div>
        </>
    )
}

export default GroupRowMobile
